import React from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { BoxMaxHeightStyled } from './styled';

const BoxMaxHeight = ({
  theme_standard_box,
  theme_standard_box_white,
  theme_gray_box,
  children,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  borderRadius,
  height,
}) => {
  const customClass = cx({
    theme_standard_box: theme_standard_box,
    theme_standard_box_white: theme_standard_box_white,
    theme_gray_box: theme_gray_box,
  });
  return (
    <BoxMaxHeightStyled
      paddingTop={paddingTop}
      paddingRight={paddingRight}
      paddingBottom={paddingBottom}
      paddingLeft={paddingLeft}
      borderRadius={borderRadius}
      height={height}
    >
      <div className={customClass}>{children}</div> 
    </BoxMaxHeightStyled>
  );
};

BoxMaxHeight.propTypes = {};

export default BoxMaxHeight;
